import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import i18n from '../i18n'; // Importar a instância do i18n
import { useUser } from './UserContext'; // Importar useUser

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const { user, loadingUser, updatePreferences } = useUser();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  useEffect(() => {
    if (!loadingUser && user) {
      // --- MODIFICAÇÃO AQUI ---
      const userLanguage = user.language_preference; // Ler user.language_preference
      // --- FIM DA MODIFICAÇÃO ---
      if (userLanguage && userLanguage !== i18n.language) {
        i18n.changeLanguage(userLanguage);
        // O estado currentLanguage será atualizado pelo listener 'languageChanged'
      }
    } else if (!loadingUser && !user) {
      // Se não houver usuário (ex: deslogado), mas i18n tiver um idioma (do localStorage/detector),
      // garante que o contexto reflita isso.
      if (i18n.language !== currentLanguage) {
        setCurrentLanguage(i18n.language);
      }
    }
  }, [user, loadingUser, currentLanguage]); // Adicionado currentLanguage

  useEffect(() => {
    const handleLanguageChanged = (lng) => {
      setCurrentLanguage(lng);
    };
    i18n.on('languageChanged', handleLanguageChanged);
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, []);

  const changeLanguage = useCallback(async (langCode) => {
    const previousLanguage = currentLanguage; // Salva o idioma atual para possível reversão
    if (langCode !== previousLanguage) {
      i18n.changeLanguage(langCode);
      // setCurrentLanguage será atualizado pelo listener

      if (user) {
        try {
          // Envia a estrutura correta para o backend
          await updatePreferences({ language_preference: langCode });
        } catch (error) {
          console.error('Erro ao atualizar preferência de idioma no backend:', error);
          // Reverte para o idioma anterior em caso de falha no backend
          i18n.changeLanguage(previousLanguage);
        }
      }
    }
  }, [currentLanguage, user, updatePreferences]);

  return (
    <LanguageContext.Provider value={{ currentLanguage, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
